<template>
  <v-row>
    <v-col
      cols="12"
      md="4"
    >
      <dashboard-card
        bg-card-color="primary"
        heading="Total channels"
        :sub-heading="`${totalChannels}`"
        main-icon-name="zmdi zmdi-tv-list"
      />
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <dashboard-card
        bg-card-color="info"
        heading="Total hours of the content"
        :sub-heading="`${totalHours}`"
        main-icon-name="zmdi zmdi-timer"
      />
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <dashboard-card
        bg-card-color="primary"
        heading="Total assets"
        :sub-heading="`${totalAssets}`"
        main-icon-name="zmdi zmdi-collection-video"
      />
    </v-col>
    <v-col
      cols="12"
      md="12"
      lg="12"
    >
      <base-card>
        <div class="shadow-none">
          <div
            class="d-flex justify-space-between flex-wrap align-center"
          >
            <v-card-title>Noisypeak Playout Dashboard</v-card-title>

            <div class="pa-2">
              <v-btn
                :disabled="loading"
                color="success"
                @click="goToNewChannel"
              >
                <i class="zmdi zmdi-plus p-r-5" />
                add channel
              </v-btn>
            </div>
          </div>
        </div>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <v-expansion-panels>
                <v-expansion-panel
                  v-for="channel of channels"
                  :key="channel.id"
                >
                  <v-expansion-panel-header
                    v-slot="{ open }"
                    hide-actions
                    @click="openChannelInfo(channel)"
                  >
                    <v-row no-gutters>
                      <v-col cols="4">
                        <v-avatar tile>
                          <v-img
                            contain
                            class="grey darken-4"
                            :src="channel.logoId ? '/api/v1/upload/' + channel.logoId + '?img.crop=50x50' : defaultIcon"
                            height="30"
                          />
                        </v-avatar>
                        {{ channel.name }}
                        <v-tooltip
                          v-if="channel.suspended"
                          color="#111"
                          top
                        >
                          <template v-slot:activator="{ on }">
                            <i
                              class="mdi mdi-pause-circle-outline red--text m-l-10"
                              v-on="on"
                            />
                          </template>
                          <div class="tooltip-body">
                            Temporarily stopped
                          </div>
                        </v-tooltip>
                      </v-col>
                      <v-col
                        cols="5"
                        class="text--secondary"
                      >
                        <v-fade-transition leave-absolute>
                          <v-row
                            v-if="open"
                            style="width: 100%"
                          >
                            <v-col cols="12">
                              On now:
                              {{ channel.currentProgram.name | truncate(200) }}
                              <span v-if="channel.currentProgram.duration">
                                [{{ moment.utc(channel.currentProgram.duration).format('HH\\h mm\\m ss\\s') }}]
                              </span>
                            </v-col>
                          </v-row>
                          <v-row
                            v-else
                            style="width: 100%"
                          >
                            <v-col cols="6">
                              Online since:
                              {{ moment(channel.createTime).utc().format('MMM D YYYY') }}
                            </v-col>
                            <v-col cols="6">
                              Scheduler: {{ channel.autoScheduler ? 'auto': 'manual' }}
                            </v-col>
                          </v-row>
                        </v-fade-transition>
                      </v-col>
                      <v-col cols="2">
                        <v-btn
                          text
                          color="success"
                          class="ma-0"
                          @click="goToChannel(channel)"
                        >
                          <i class="zmdi zmdi-settings p-r-10" />Details
                        </v-btn>
                      </v-col>
                      <v-col cols="1">
                        <div class="table-data-feature">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                text
                                icon
                                class="m-0 item"
                                v-on="on"
                                @click="goToEdit(channel)"
                              >
                                <i class="zmdi zmdi-edit" />
                              </v-btn>
                            </template>
                            <span>Edit</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                text
                                icon
                                class="m-0 item"
                                v-on="on"
                                @click.stop="openRemoveDialog(channel)"
                              >
                                <i class="zmdi zmdi-delete" />
                              </v-btn>
                            </template>
                            <span>Delete</span>
                          </v-tooltip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="min-height: 400px;">
                    <v-row>
                      <v-col
                        cols="12"
                      >
                        <iframe
                          id="streamFrameSrc"
                          class="iframe-center"
                          :src="channel.streamFrameSrc"
                          scrolling="no"
                          height="380"
                          width="100%"
                          frameborder="0"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-card-text>
      </base-card>
    </v-col>
    <!-- Channel Remove Dialog -->
    <v-dialog
      v-model="removeDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Delete channel?
        </v-card-title>
        <v-card-text>
          <div class="row p-b-20">
            <div class="col-md-12">
              Are you sure you want to delete the channel "{{ deletedChannel.name }}"?
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            text
            @click="removeDialog = false"
          >
            No
          </v-btn>
          <v-btn
            depressed
            color="error"
            @click="deleteChannel()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { processChannel, processProgram2, processDistribution } from '@/store/converters'
  import moment from 'moment-timezone'
  import DashboardCard from '@/components/card/DashboardCard'

  export default {
    name: 'Dashboard',
    metaInfo: {
      title: 'Dashboard',
    },
    components: {
      DashboardCard,
    },
    data () {
      return {
        polling: null,
        totalHours: 0,
        totalAssets: 0,
        channels: [],
        deletedChannel: {},
        removeDialog: false,
        activeRow: -1,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      totalChannels () {
        return this.channels.length
      },
      defaultIcon () {
        return '/images/default_channel_logo.png'
      },
    },
    created () {
      this.loadData()
      this.pollData()
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      loadData () {
        this.$store.commit('setPageLoader')

        const channelReq = this.$store.dispatch('channels', {
          expand: '',
        })
        const overviewReq = this.$store.dispatch('overview')

        const distributionReqArgs = {
          'default[eq]': 1,
        }
        const distributionReq = this.$store.dispatch('distributions', distributionReqArgs)

        Promise.all([channelReq, overviewReq, distributionReq])
          .then((result) => {
            const channels = result[0] || []
            this.channels = channels.map((c) => processChannel(c))

            const distributions = (result[2] || []).map((d) => processDistribution(d))
            const distributionMap = {}
            for (let i = 0; i < distributions.length; i += 1) {
              const d = distributions[i]
              for (const key in d.urls) {
                if (key === 'hls3') {
                  distributionMap[d.channelId] = d.urls[key]
                }
              }
            }

            for (let i = 0; i < this.channels.length; i += 1) {
              const ch = this.channels[i]
              let streamURL = ch.streamURLhlsv3
              // eslint-disable-next-line no-prototype-builtins
              if (distributionMap.hasOwnProperty(ch.id)) {
                streamURL = distributionMap[ch.id]
              }
              streamURL = streamURL.replace('$origin', 'now')
              streamURL = streamURL.replace('$offset', '-1m_15s')
              streamURL = streamURL.replace(',', '_')
              this.channels[i].streamURL = streamURL
              this.channels[i].streamFrameSrc = ''
              this.channels[i].currentProgram = {
                name: '',
              }
            }

            const overview = result[1]
            this.totalAssets = overview.asset_count
            this.totalHours = overview.transcoded_hour_count
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      setActiveRow (i) {
        this.activeRow = i
      },
      pollData () {
        this.polling = setInterval(() => {
        // this.loadData();
        }, 10000)
      },
      goToChannel (channel) {
        this.$router.push({
          name: 'SchedulerPage',
          params: {
            id: channel.id,
          },
        })
      },
      openRemoveDialog (channel) {
        this.deletedChannel = channel
        this.removeDialog = true
      },
      deleteChannel () {
        if (!this.deletedChannel.id) return

        this.$store.commit('setPageLoader')
        this.$store.dispatch('deleteChannel', this.deletedChannel.id)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The channel has been successfully removed',
              timeout: 6000,
              color: 'success',
            })
            this.loadData(true)
            this.deletedChannel = {}
            this.removeDialog = false
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      goToEdit (channel) {
        this.$router.push({
          name: 'ChannelEditPage',
          params: {
            id: channel.id,
          },
        })
      },
      goToNewChannel () {
        this.$router.push({
          name: 'NewChannelPage',
        })
      },
      openChannelInfo (channel) {
        for (let i = 0; i < this.channels.length; i += 1) {
          if (channel.id === this.channels[i].id) {
            // eslint-disable-next-line no-param-reassign
            channel.streamFrameSrc = `/js/radiant/index3.html?src=${channel.streamURL}`
          } else {
            this.channels[i].streamFrameSrc = ''
          }
        }
        const params = {
          'end_time[gt]': `${moment().utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
          'channel.id[eq]': channel.id,
          $limit: 1,
          $expand: 'items',
        }
        this.$store.dispatch('programs2', params)
          .then((programs) => {
            if (programs.length > 0) {
              // eslint-disable-next-line no-param-reassign
              channel.currentProgram = processProgram2(programs[0])
            } else {
              // eslint-disable-next-line no-param-reassign
              channel.currentProgram.name = '-----'
            }
          })
          .catch((errorMsg) => {
            // eslint-disable-next-line no-param-reassign
            channel.currentProgram.name = '-----'
            console.log('error getting current program', errorMsg)
          })
      },
    },
  }
</script>

<style lang="scss" scoped>
.iframe-center {
  display: block;
  margin: 0 auto;
}
</style>
